import { motion, AnimatePresence } from "framer-motion";
import { Zap } from "lucide-react";

export const CreditUpsellModal = ({ isOpen, onClose, onNavigate, creditsNeeded = 1, currentCredits = 0 }) => {
  if (!isOpen) return null;
  
  const packages = [
    { name: "1 Credit", credits: 1, price: "$2", popular: false },
    { name: "7 Credits", credits: 7, price: "$10", popular: true },
    { name: "25 Credits", credits: 25, price: "$29.99", popular: false },
  ];

  return (
    <AnimatePresence>
      <motion.div
        data-testid="credit-upsell-modal"
        className="fixed inset-0 z-[100] flex items-center justify-center"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} />
        <motion.div
          className="relative bg-[#0a0a0a] border border-gold/30 rounded-2xl p-6 max-w-md w-full mx-4 shadow-2xl shadow-gold/10"
          initial={{ scale: 0.9, y: 20 }}
          animate={{ scale: 1, y: 0 }}
          exit={{ scale: 0.9, y: 20 }}
        >
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-gold/0 via-gold to-gold/0 rounded-t-2xl" />
          <div className="text-center mb-5">
            <div className="w-14 h-14 bg-gold/10 rounded-full flex items-center justify-center mx-auto mb-3">
              <Zap className="w-7 h-7 text-gold" />
            </div>
            <h3 className="text-xl font-bold text-white">Need More Credits</h3>
            <p className="text-white/50 text-sm mt-1">
              You have <span className="text-gold font-semibold">{currentCredits}</span> credits. 
              This action requires <span className="text-white font-semibold">{creditsNeeded}</span>.
            </p>
          </div>
          <div className="space-y-2 mb-5">
            {packages.map((pkg) => (
              <button
                key={pkg.name}
                data-testid={`upsell-package-${pkg.name.toLowerCase()}`}
                onClick={() => { onClose(); onNavigate("/pricing"); }}
                className={`w-full p-3 rounded-xl flex items-center justify-between transition-all ${
                  pkg.popular 
                    ? "bg-gold/15 border-2 border-gold hover:bg-gold/25" 
                    : "bg-white/5 border border-white/10 hover:bg-white/10"
                }`}
              >
                <div className="text-left">
                  <div className="flex items-center gap-2">
                    <span className="text-white font-semibold text-sm">{pkg.name}</span>
                    {pkg.popular && <span className="text-[10px] bg-[#D4AF37] text-black px-1.5 py-0.5 rounded-full font-bold">BEST VALUE</span>}
                  </div>
                  <span className="text-white/40 text-xs">{pkg.credits} {pkg.credits === 1 ? 'credit' : 'credits'}</span>
                </div>
                <span className={`font-bold text-sm ${pkg.popular ? "text-gold" : "text-white"}`}>{pkg.price}</span>
              </button>
            ))}
          </div>
          <button data-testid="upsell-close" onClick={onClose} className="w-full text-white/40 text-xs hover:text-white/60 transition-colors py-1">
            Maybe later
          </button>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};
